<script setup>
import CallTypeIcon from "@/components/Telephony/CallTypeIcon.vue";

defineProps({
    item: {
        type: Object,
        default: () => ({})
    }
})

// the labels the box takes its width from; answered_elsewhere is left out
// and wraps inside that width instead
const SIZER_KEYS = [
    'telephony.call_types.incoming',
    'telephony.call_types.outgoing',
    'telephony.call_statuses.missed',
    'telephony.call_statuses.answered',
]
</script>

<template>
    <div class="item-type">
        <CallTypeIcon class="item-type__icon" :item="item"/>
        <div class="item-type__info">
            <p class="item-type__type">
                {{
                    $t(`telephony.call_types.${item.call_type}`)
                }}
            </p>
            <p class="item-type__status" :class="[`--${item.status}`]">
                {{
                    $t(`telephony.call_statuses.${item.status}`)
                }}
            </p>
            <span class="item-type__sizer" aria-hidden="true">
                <span v-for="key in SIZER_KEYS" :key="key">{{ $t(key) }}</span>
            </span>
        </div>
    </div>
</template>

<style scoped lang="scss">
// every row gets a box as wide as the longest label, centred in the cell,
// with its content on the left: the column stays centred and the arrows line up
.item-type {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto;

    &__info {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        // the table cells centre their text, a wrapped status would too
        text-align: left;
    }

    &__type,
    &__status {
        color: #212529;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        // the two-line "answered in app" keeps the row low
        line-height: 20px;

        &.--missed {
            color: #DF7070;
        }

        &.--answered {
            color: #70DF7B;
        }

        &.--answered_elsewhere {
            color: var(--border-primary-color);
        }
    }

    // adds no width of its own, wraps inside what the sizer sets
    &__status {
        contain: inline-size;
    }

    // must be set like the labels above, or it measures the wrong width
    &__sizer {
        display: block;
        height: 0;
        overflow: hidden;
        visibility: hidden;
        font-size: 15px;

        span {
            display: block;
        }
    }
}
</style>
